import { PaymentCount } from './../model/payment-summary';

export const mockPaymentCount: PaymentCount = {
  paymentCount: 1
}
